<template>
  <v-app class="base">
    <v-app-bar app :color="getColor()" clipped-left dark>
      <v-container fluid :class="`d-flex justify-space-between`">
        <div v-if="$store.state.auth">
          <v-app-bar-nav-icon
            color="grey"
            @click="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </div>
        <div v-else></div>
        <div class="d-flex align-center black--text" style="font-size:18pt">
          {{ title }} : {{ version }}
        </div>
        <div v-if="$store.state.auth" @click="drawer = false">
          <!--<amplify-sign-out />-->
          <v-btn @click="signOut">サインアウト</v-btn>
        </div>
        <div v-else></div>
      </v-container>
    </v-app-bar>
    <div>
      <v-main>
        <MainMenu />
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
      <v-footer class="base"> </v-footer>
    </div>
  </v-app>
</template>

<script>
import MainMenu from "./components/MainMenu";
import { Auth } from "aws-amplify";

export default {
  name: "App",
  components: {
    MainMenu,
  },
  data: () => ({
    drawer: false,
    url: null,
    title: "統合開発環境 生成システム",
    version: "0.0.0",
  }),
  mounted() {
    //環境別処理
    if (process.env.NODE_ENV == "development") {
      this.title = "ローカル環境";
    }
    //バージョン追記
    if (!this.$store.state.auth) {
      this.drawer = false;
    }
    this.version =
      typeof process.env.VUE_APP_VERSION != "undefined"
        ? process.env.VUE_APP_VERSION
        : this.version;
    //this.version = process.env.major_version + process.env.minor_version;
  },
  methods: {
    async signOut() {
      try {
        await Auth.signOut();
        this.$router.push("/login");
        this.$store.commit("logOut");
        this.drawer = false;
      } catch (error) {
        console.log(error);
      }
    },
    getColor() {
      if (process.env.NODE_ENV == "development") {
        return "deep-orange lighten-5";
      }
      return "amber lighten-2";
    },
  },
};
</script>
<style>
@import "../css/styles.css";
</style>
